import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";
import Logo from "@/components/Logo";

export default function CTA() {
  return (
    <section data-testid="cta-section" className="relative py-16 sm:py-20 bg-secondary/30 dark:bg-secondary/20 border-t hairline">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="relative overflow-hidden rounded-4xl lg:rounded-5xl bg-brand-ink text-white grain hairline">
          <div className="absolute inset-0 opacity-70">
            <div className="absolute -top-40 -left-20 h-96 w-96 rounded-full bg-brand-gradient blur-3xl opacity-70" />
            <div className="absolute -bottom-40 -right-20 h-96 w-96 rounded-full bg-brand-gradient blur-3xl opacity-70" />
          </div>
          <div className="relative px-8 sm:px-14 py-16 sm:py-24 lg:py-28 grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
            <div className="lg:col-span-8">
              <div className="font-mono text-xs tracking-[0.25em] uppercase text-white/60 mb-6">
                § Start
              </div>
              <motion.h2
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                className="font-heading text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-[-0.03em] leading-[1.05]"
              >
                Ready to modernize your dental workflow?
              </motion.h2>
              <p className="mt-6 text-base sm:text-lg text-white/70 max-w-xl leading-relaxed">
                Free for doctors. Simple, transparent pricing for labs. See Rxn3D end-to-end in a personalized walkthrough — no credit card, no commitment.
              </p>
            </div>

            <div className="lg:col-span-4 flex lg:justify-end">
              <div className="flex flex-col gap-3 w-full lg:max-w-xs">
                <Link
                  to="/request-demo"
                  data-testid="cta-request-demo"
                  className="group inline-flex items-center justify-center gap-2 px-6 py-4 rounded-full bg-white text-brand-ink font-semibold text-sm hover:opacity-90 transition-opacity"
                >
                  Request demo
                  <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </Link>
                <Link
                  to="/pricing"
                  data-testid="cta-see-pricing"
                  className="group inline-flex items-center justify-center gap-2 px-6 py-4 rounded-full border border-white/20 hover:bg-white/5 text-sm font-medium transition-colors"
                >
                  See pricing
                </Link>
              </div>
            </div>
          </div>

          <div className="relative border-t border-white/10 px-8 sm:px-14 py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
            <div className="flex items-center gap-3">
              <Logo size="md" withGlow={false} variant="dark" testId="cta-logo" />
              <span className="text-xs text-white/60">Rxn3D · Modern dental lab management</span>
            </div>
            {/* <div className="text-xs text-white/60">sales@rxn3d.com · support@rxn3d.com</div> */}
          </div>
        </div>
      </div>
    </section>
  );
}
